/**
 * @class
 * @public
 */
export default class RestrictionOnActionViewModel {
  constructor({ interviewDate, restrictionPeriod, message } = {}) {
    /**
     * The interview date that the restriction is based on.
     * For config-driven restrictions, defaults to DateTime.MaxValue.
     * @type {String}
     */
    this.interviewDate = interviewDate
    /**
     * The restriction period type.
     * For config-driven restrictions, defaults to PostInterview.
     * @type {String}
     */
    this.restrictionPeriod = restrictionPeriod
    /**
     * A message to show to the user explaining the restriction.
     * Only set for config-driven restrictions.
     * @type {String | null}
     */
    this.message = message ?? null
  }

  /**
   * Determines if this is a config-driven restriction.
   * Config-driven restrictions have a message property populated.
   * @returns {Boolean}
   */
  get isConfigDriven() {
    return !!this.message
  }
}
